/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBarBoth = createReactComponent("outline", "arrow-bar-both", "IconArrowBarBoth", [["path", { "d": "M8 12h-6", "key": "svg-0" }], ["path", { "d": "M5 15l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M22 12h-6", "key": "svg-2" }], ["path", { "d": "M19 15l3 -3l-3 -3", "key": "svg-3" }], ["path", { "d": "M12 4v16", "key": "svg-4" }]]);

export { IconArrowBarBoth as default };
//# sourceMappingURL=IconArrowBarBoth.mjs.map
